export function extractVimeoId(url) {
  const regex = (
    // For some reason it thinks that the last \/ is unnecessary, but the entire regex becomes illegal if that's removed.
    /^(?:https?:\/\/)?(?:www\.)?(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)[^\s/]*$/g
  );
  const matches = Array.from(url.matchAll(regex))[0];
  return matches?.[1];
}
export function extractYouTubeId(url) {
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[7].length === 11 ? match[7] : null;
}
export function buildYouTubeThumbnailUrl(id, size = "maxresdefault") {
  return `https://i3.ytimg.com/vi/${id}/${size}.jpg`;
}
